import ApprovalsNew from './ApprovalsNew';

export default ApprovalsNew;



